import { render, staticRenderFns } from "./ObjectInfoFeaturesForGroup.vue?vue&type=template&id=2cb58282"
import script from "./ObjectInfoFeaturesForGroup.vue?vue&type=script&lang=js"
export * from "./ObjectInfoFeaturesForGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports